// argumnets @orderleveldata

import properties from '../modules/ajio-util/properties';
import { gtmEventPush, segmentEventPush, getStoreName } from '../modules/ga/GTMdatalayer';

const ORDER_TYPES = {
  STORE_PICKUP: 'store-pickup'
};

const isOrderPickup = ({ deliveryModeValue = '' }) =>
  deliveryModeValue === ORDER_TYPES.STORE_PICKUP;

const getIconStyles = ({ headerIconColor = '#FFFFFF', buttonPatchColor = '#2c4152' }) => ({
  color: headerIconColor,
  backgroundColor: buttonPatchColor
});

const getFeedbackRatingInWord = rating => {
  let ratingInWords = '';
  switch (+rating) {
    case 0:
    case 1:
    case 2:
    case 3:
      ratingInWords = 'bad';
      break;

    case 4:
    case 5:
    case 6:
      ratingInWords = 'ok';
      break;

    case 7:
    case 8:
      ratingInWords = 'good';
      break;

    case 9:
    case 10:
      ratingInWords = 'excellent';
      break;

    default:
      ratingInWords = '';
      break;
  }
  return ratingInWords;
};
const getSuggestions = suggestions =>
  suggestions.reduce(
    (acc, item) => {
      const { data_type } = item;
      if (data_type !== 'STORE') {
        acc.textsuggestions = [...acc.textsuggestions, item];
      } else {
        acc.storeSuggestions = [...acc.storeSuggestions, item];
      }
      return acc;
    },
    {
      textsuggestions: [],
      storeSuggestions: []
    }
  );

const getSearchUrl = suggestionUrl => {
  // const urlSplits = suggestionUrl.split(":");
  let autoSuggestionUrl = `/search/?text=${suggestionUrl.trim()}`;
  // if (urlSplits[0] == "categoryID" || urlSplits[0] == "brands") {
  //   autoSuggestionUrl = `/search/?text=${suggestionUrl.trim()}`;
  // }
  if (suggestionUrl.includes('http')) {
    autoSuggestionUrl = suggestionUrl;
  }
  return autoSuggestionUrl;
};

const redirect = (url = '') => () => {
  window.location.href = url;
};

const isCatalogNameInFirebaseStore = (storesArr, catalogName) => {
  return !storesArr.includes(catalogName);
};

const isRilDomain = (domains, email = '') => {
  const emaildomain = email.split('@')[1];
  return domains.some(ele => ele == emaildomain);
};

const showAlertWhenSectionInView = sectionId => {
  const section = document.getElementById(sectionId);
  if (!section) {
    return;
  }
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.setAttribute('aria-hidden', 'false');
      } else {
        entry.target.setAttribute('aria-hidden', 'true');
      }
    });
  });
  observer.observe(section);
};

const isLandingPage = () => {
  const { pathname } = window.location;
  return pathname === '/' || pathname.includes('/shop/');
};

const addQueryParams = (url, paramsObj) => {
  let urlObj = new URL(url);
  let params = new URLSearchParams(urlObj.search);
  Object.keys(paramsObj)?.forEach(param => {
    const paramValue = paramsObj[param];
    if (paramValue) {
      params.set(param, paramValue);
    }
  });
  urlObj.search = params ? params.toString() : '';
  return urlObj.toString();
};

const getProductAttributionToken = (skuId) => {
  const storename = String(window?.__PRELOADED_STATE__?.metaData?.name).toLowerCase()
  if (storename !== '' && storename !== 'ajio' && storename !== 'rilfnl') return '';

  if (!skuId) return '';

  const rawCartMap = localStorage.getItem('cartAttributionMap');
  if (!rawCartMap) return '';

  try {
    const cartMap = JSON.parse(rawCartMap);
    return cartMap?.[skuId] || '';
  } catch (error) {
    console.error('Failed to parse cartAttributionMap from localStorage', error);
    return '';
  }
}

 const getCopilotSkuCheck = (skuId) => {
  if (!skuId) return '';

  try {
    const raw = localStorage.getItem('copilotMap');
    if (!raw) return '';

    const now = Date.now();
    const map = JSON.parse(raw);
    const entry = map?.[skuId];

    if (entry?.source === 'copilot' && now < entry.expiry) {
      return 'copilot';
    } else if (entry) {
      delete map[skuId];
      localStorage.setItem('copilotMap', JSON.stringify(map));
    }
  } catch (error) {
    console.error('Failed to read or parse copilotMap from localStorage', error);
  }

  return '';
};


function getValidAttributionToken(){
  try {
    const storename = String(window?.__PRELOADED_STATE__?.metaData?.name).toLowerCase()
    // if (storename !== '' && storename !== 'ajio' && storename !== 'rilfnl') return '';
    
    const stored = JSON.parse(localStorage.getItem('attributionToken') || '{}');
    const now = Date.now();

    if (stored?.value && now < stored.expiry) {
      return stored.value;
    } else {
      localStorage.removeItem('attributionToken');
    }
  } catch {
    localStorage.removeItem('attributionToken');
  }
  return null;
}

function getStoredPageCategory() {
  try {
    const stored = localStorage.getItem('pageCategory');
    if (stored) return stored;
    const breadcrumb =
      window?.__PRELOADED_STATE__?.productsAdditionalInfo?.rilfnlBreadCrumbList?.rilfnlBreadCrumb;
    if (Array.isArray(breadcrumb) && breadcrumb.length > 0) {
      const isSearchOrFind =
        window.location.pathname.startsWith('/search') ||
        window.location.pathname.startsWith('/find');
      const computed = breadcrumb
        .map(b => {
          let name = b?.name || '';
          if (isSearchOrFind) name = name?.split(':')[0] || name;
          return name?.trim();
        })
        .filter(Boolean)
        .join(' > ');
      if (computed) {
        localStorage.setItem('pageCategory', computed);
        return computed;
      }
    }
    return '';
  } catch {
    return '';
  }
}

const deleteProductAttributionToken = (skuId) => {
  if (!skuId) return;

  const rawCartMap = localStorage.getItem('cartAttributionMap');
  if (!rawCartMap) return;
  
  try {
  const cartMap = JSON.parse(rawCartMap);
  if (cartMap?.hasOwnProperty(skuId)) {
  delete cartMap[skuId];
  localStorage.setItem('cartAttributionMap', JSON.stringify(cartMap));
  }
  } catch (error) {
  console.error('Failed to parse or update cartAttributionMap in localStorage', error);
  }
  };

  function isCopilotReferrer() {
    const params = new URLSearchParams(window.location.search);
    return (
      params.get('plp_source_details') === 'ai_assistant_widget' ||
      params.get('itm_source_detail') === 'ai_assistant_widget'
    );
  }

  function isCrossSellReferrer() {
    const params = new URLSearchParams(window.location.search);
    return params.get('itm_source') === 'widget';
  }
  
  function trackCopilotMap(vertexUniqueKey, copilotSource) {
    const TTL = 60 * 60 * 1000; // 60 minutes
  
    if (copilotSource && vertexUniqueKey) {
      try {
        const now = Date.now();
        const existingMap = JSON.parse(localStorage.getItem('copilotMap') || '{}');
        existingMap[vertexUniqueKey] = {
          source: 'copilot',
          expiry: now + TTL
        };
        localStorage.setItem('copilotMap', JSON.stringify(existingMap));
      } catch (e) {
        console.error('Failed to update copilotMap', e);
      }
    }
  }

  const getQuantityByCode = (orderLevelDetail, productCode) => {
    const entries = orderLevelDetail?.orderResponse?.entries || [];
    const matchedEntry = entries.find(entry => entry?.product?.code === productCode);
    return matchedEntry?.quantity ?? 0;
  };

const CROSS_SELL_WIDGET_MAP_KEY = 'crossSellWidgetMap';

const setCrossSellWidgetSource = (productCode, widgetTitle) => {
  if (!productCode || !widgetTitle) return;
  try {
    const raw = sessionStorage.getItem(CROSS_SELL_WIDGET_MAP_KEY);
    const map = raw ? JSON.parse(raw) : {};
    map[productCode] = widgetTitle;
    sessionStorage.setItem(CROSS_SELL_WIDGET_MAP_KEY, JSON.stringify(map));
  } catch (e) {
    console.error('Failed to set crossSellWidgetMap in sessionStorage', e);
  }
};

const getCrossSellWidgetSource = (skuId) => {
  if (!skuId) return '';
  try {
    const raw = sessionStorage.getItem(CROSS_SELL_WIDGET_MAP_KEY);
    if (!raw) return '';
    const map = JSON.parse(raw);
    return map?.[skuId] || '';
  } catch (e) {
    console.error('Failed to get crossSellWidgetMap from sessionStorage', e);
    return '';
  }
};

export {
  ORDER_TYPES,
  isOrderPickup,
  getIconStyles,
  getFeedbackRatingInWord,
  getSuggestions,
  getSearchUrl,
  redirect,
  isCatalogNameInFirebaseStore,
  isRilDomain,
  showAlertWhenSectionInView,
  addQueryParams,
  getProductAttributionToken,
  getValidAttributionToken,
  getStoredPageCategory,
  deleteProductAttributionToken,
  isLandingPage,
  isCopilotReferrer,
  isCrossSellReferrer,
  trackCopilotMap,
  getCopilotSkuCheck,
  getQuantityByCode,
  setCrossSellWidgetSource,
  getCrossSellWidgetSource
};
